// extracted by mini-css-extract-plugin
export default {"wrapper":"BannerCard_wrapper__h34EG","icon":"BannerCard_icon__iRHl+"};